export abstract class IOpenHoursService {
  public abstract setOpenHours(openHours);
  public abstract setSpecialOpenHours(specialOpenHours);
  public abstract setTempClosed(tempClosed);
  public abstract getOpenHoursToSave();
  public abstract getSpecialOpenHoursToSave();
  public abstract getTempClosed();
}
